// src/services/skillService.js
import { db } from "../firebase";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";

const skillsCollection = collection(db, "skills");

export const getSkills = async () => {
  const snapshot = await getDocs(skillsCollection);
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

export const createSkill = async (skillData) => {
  const docRef = await addDoc(skillsCollection, skillData);
  return docRef.id;
};

export const updateSkill = async (skillId, updatedData) => {
  const skillDoc = doc(db, "skills", skillId);
  await updateDoc(skillDoc, updatedData);
};

export const deleteSkill = async (skillId) => {
  const skillDoc = doc(db, "skills", skillId);
  await deleteDoc(skillDoc);
};
